/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-wrap:wrap;width:800px}mat-form-field.street[_ngcontent-%COMP%]{flex-basis:100%}mat-form-field.city[_ngcontent-%COMP%]{flex-basis:55%}mat-form-field.state[_ngcontent-%COMP%]{flex-basis:10%}mat-form-field.zip[_ngcontent-%COMP%]{flex-basis:15%}mat-form-field.country[_ngcontent-%COMP%]{flex-basis:100%}"];
export { styles as styles };
